const ACTION_TYPES = {
    BANNER:{
        GET_ALL_BANNER_START: 'GET_ALL_BANNER_START',
        GET_ALL_BANNER_FAILED: 'GET_ALL_BANNER_FAILED',
        GET_ALL_BANNER_SUCCESS: 'GET_ALL_BANNER_SUCCESS',
    },
    USER:{
        POST_REGISTER_START: 'POST_REGISTER_START',
        POST_REGISTER_FAILED: 'POST_REGISTER_FAILED',
        POST_REGISTER_SUCCESS: 'POST_REGISTER_SUCCESS',
        POST_LOGIN_START: 'POST_LOGIN_START',
        POST_LOGIN_FAILED: 'POST_LOGIN_FAILED',
        POST_LOGIN_SUCCESS: 'POST_LOGIN_SUCCESS',
        GET_USER_START:"GET_USER_START",
        GET_USER_FAILED:"GET_USER_FAILED",
        GET_USER_SUCCES:"GET_USER_SUCCES",
        GET_EMAIL_VALIDATION_START:"GET_EMAIL_VALIDATION_START",
        GET_EMAIL_VALIDATION_FAILED:"GET_EMAIL_VALIDATION_FAILED",
        GET_EMAIL_VALIDATION_SUCCESS:"GET_EMAIL_VALIDATION_SUCCESS",
    },
    CAMPAIGN: {
        GET_PRIORITY_CAMPAIGN_START: 'GET_PRIORITY_CAMPAIGN_START',
        GET_PRIORITY_CAMPAIGN_FAILED: 'GET_PRIORITY_CAMPAIGN_FAILED',
        GET_PRIORITY_CAMPAIGN_SUCCESS: 'GET_PRIORITY_CAMPAIGN_SUCCESS',
        GET_ID_CAMPAIGN_START: 'GET_ID_CAMPAIGN_START',
        GET_ID_CAMPAIGN_FAILED: 'GET_ID_CAMPAIGN_FAILED',
        GET_ID_CAMPAIGN_SUCCESS: 'GET_ID_CAMPAIGN_SUCCESS',
        POST_FORM_CAMPAIGN_START: 'POST_FORM_CAMPAIGN_START',
        POST_FORM_CAMPAIGN_FAILED: 'POST_FORM_CAMPAIGN_FAILED',
        POST_FORM_CAMPAIGN_SUCCESS: 'POST_FORM_CAMPAIGN_SUCCESS',
        GET_CATEGORY_CAMPAIGN_START: 'GET_CATEGORY_CAMPAIGN_START',
        GET_CATEGORY_CAMPAIGN_FAILED: 'GET_CATEGORY_CAMPAIGN_FAILED',
        GET_CATEGORY_CAMPAIGN_SUCCESS: 'GET_CATEGORY_CAMPAIGN_SUCCESS',
    },
    MYPAGE: {
        GET_EXPERIENCE_START: 'GET_EXPERIENCE_START',
        GET_EXPERIENCE_FAILED: 'GET_EXPERIENCE_FAILED',
        GET_EXPERIENCE_SUCCESS: 'GET_EXPERIENCE_SUCCESS',
        GET_INVITATION_START: 'GET_INVITATION_START',
        GET_INVITATION_FAILED: 'GET_INVITATION_FAILED',
        GET_INVITATION_SUCCESS: 'GET_INVITATION_SUCCESS',
        GET_INVITATION_ATTEND_START: 'GET_INVITATION_ATTEND_START',
        GET_INVITATION_ATTEND_FAILED: 'GET_INVITATION_ATTEND_FAILED',
        GET_INVITATION_ATTEND_SUCCESS: 'GET_INVITATION_ATTEND_SUCCESS',
        PATCH_ATTEND_INVITATION_START: 'PATCH_ATTEND_INVITATION_START',
        PATCH_ATTEND_INVITATION_FAILED: 'PATCH_ATTEND_INVITATION_FAILED',
        PATCH_ATTEND_INVITATION_SUCCESS: 'PATCH_ATTEND_INVITATION_SUCCESS',
        POST_REVIEW_FORM_START: 'POST_REVIEW_FORM_START',
        POST_REVIEW_FORM_FAILED: 'POST_REVIEW_FORM_FAILED',
        POST_REVIEW_FORM_SUCCESS: 'POST_REVIEW_FORM_SUCCESS',
        GET_REVIEW_START: 'GET_REVIEW_START',
        GET_REVIEW_FAILED: 'GET_REVIEW_FAILED',
        GET_REVIEW_SUCCESS: 'GET_REVIEW_SUCCESS',
        POST_IMAGE_TRACKER_START: 'POST_IMAGE_TRACKER_START',
        POST_IMAGE_TRACKER_FAILED: 'POST_IMAGE_TRACKER_FAILED',
        POST_IMAGE_TRACKER_SUCCESS: 'POST_IMAGE_TRACKER_SUCCESS',
        PUT_CANCEL_CAMPAIGN_START: 'PUT_CANCEL_CAMPAIGN_START',
        PUT_CANCEL_CAMPAIGN_FAILED: 'PUT_CANCEL_CAMPAIGN_FAILED',
        PUT_CANCEL_CAMPAIGN_SUCCESS: 'PUT_CANCEL_CAMPAIGN_SUCCESS',
        PUT_PROFILE_START: 'PUT_PROFILE_START',
        PUT_PROFILE_FAILED: 'PUT_PROFILE_FAILED',
        PUT_PROFILE_SUCCESS: 'PUT_PROFILE_SUCCESS',
        PUT_PASSWORD_START: 'PUT_PASSWORD_START',
        PUT_PASSWORD_FAILED: 'PUT_PASSWORD_FAILED',
        PUT_PASSWORD_SUCCESS: 'PUT_PASSWORD_SUCCESS',
    }
}

export default ACTION_TYPES;